import Repository from '../axios'
import {
  defaultPagination
} from "@/constants/config";
const resource = "/admin/system_setting";

export default {
  getIncoterms(id) {
    return Repository.get(`${resource}/incoterms/${id}`)
  },
  getListOfIncoterms(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/incoterms?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createIncoterms(payload) {
    return Repository.post(`${resource}/incoterms`, payload)
  },
  deleteIncoterms(id) {
    return Repository.delete(`${resource}/incoterms/${id}`)
  },
  updateIncoterms(id, payload) {
    return Repository.put(`${resource}/incoterms/${id}`, payload)
  }
};
